/**
 * Takes a string phrase and breaks it into separate phrases
 * no bigger than 'maxwidth', breaks are made at complete words.
 *
 * @param {String} str Label Text
 * @param {Int} maxwidth Width in characters
 * @returns
 */
function formatLabel(str, maxwidth) {
  return str.split(" ")[0];
}

export default formatLabel;
